
function convertFractionToDecimal(fraction) {
    let parts = fraction.replace('"', " ").replace("  ", " ").split(" ");
    var total = 0.0;
    parts.forEach((part) => {
      if (part.includes("/")) {
        let sides = part.split("/");
        const numberOne = parseFloat(sides[0]);
        const numberTwo = parseFloat(sides[1]);
        if (!isNaN(numberOne) && !isNaN(numberTwo) && numberTwo !== 0) {
          total += numberOne / numberTwo;
        }
      } else {
        if (parseFloat(part)) total += parseFloat(part);
      }
    });
    if(total === Math.floor(total)) {
        return `${parseInt(total)}`;
    }
    return total.toFixed(3);
}

function convertDecimalToFraction(decimal) {
    const tolerance = 1.0e-6; // Tolerance level
    let numerator = 1;
    let denominator = 1;
    let lowerN = 0;
    let lowerD = 1;
    let upperN = 1;
    let upperD = 0;
    let fraction = numerator / denominator;
    let whole = Math.floor(decimal);
    let remainder = decimal - whole;
  
    if (Math.abs(remainder) < tolerance) {
      return `${whole}`;
    }
  
    while (Math.abs(fraction - remainder) > tolerance) {
      if (fraction < remainder) {
        lowerN = numerator;
        lowerD = denominator;
        numerator += upperN;
        denominator += upperD;
      } else {
        upperN = numerator;
        upperD = denominator;
        numerator += lowerN;
        denominator += lowerD;
      }
      fraction = numerator / denominator;
    }
    if (whole > 0) {
      return `${whole} ${numerator}/${denominator}`;
    }
    return `${numerator}/${denominator}`;
}

export { convertDecimalToFraction, convertFractionToDecimal }